"use strict";
/** @module models */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SCURuleOnWebsocket = exports.SCURuleOnZone = exports.SCURuleOnAlertingConnection = exports.SCURuleOnToneDetect = exports.SCURuleOnAPITrigger = exports.SCURuleOnCron = exports.SCURuleOnInput = exports.SCURuleOnAssignment = exports.SCURuleEventType = exports.SCURuleOnEvent = exports.SCUTriggerType = exports.SCURuleOn = void 0;
var cerealParse_1 = require("../cerealParse");
var scuConfig_1 = require("./scuConfig");
var SCURuleOn = /** @class */ (function () {
    function SCURuleOn(trigger) {
        this.trigger = trigger;
    }
    SCURuleOn.parse = function (o) {
        try {
            var trigger = cerealParse_1.ParseUtils.getEnum(o, 'trigger', SCUTriggerType);
            switch (trigger) {
                case SCUTriggerType.onEvent:
                    return SCURuleOnEvent.parse(o);
                case SCUTriggerType.onAssignment:
                    return SCURuleOnAssignment.parse(o);
                case SCUTriggerType.onInput:
                    return SCURuleOnInput.parse(o);
                case SCUTriggerType.onCron:
                    return SCURuleOnCron.parse(o);
                case SCUTriggerType.onApiTrigger:
                    return SCURuleOnAPITrigger.parse(o);
                case SCUTriggerType.onToneDetect:
                    return SCURuleOnToneDetect.parse(o);
                case SCUTriggerType.onAlertingConnection:
                    return SCURuleOnAlertingConnection.parse(o);
                case SCUTriggerType.onZone:
                    return SCURuleOnZone.parse(o);
                case SCUTriggerType.onWebsocket:
                    return SCURuleOnWebsocket.parse(o);
                default:
                    return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleOnEvent Model: Unhandled trigger '" + SCUTriggerType[trigger] + "'");
            }
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleOnEvent Model: " + e.message);
        }
    };
    return SCURuleOn;
}());
exports.SCURuleOn = SCURuleOn;
var SCUTriggerType;
(function (SCUTriggerType) {
    SCUTriggerType[SCUTriggerType["onEvent"] = 0] = "onEvent";
    SCUTriggerType[SCUTriggerType["onAssignment"] = 1] = "onAssignment";
    SCUTriggerType[SCUTriggerType["onInput"] = 2] = "onInput";
    SCUTriggerType[SCUTriggerType["onCron"] = 3] = "onCron";
    SCUTriggerType[SCUTriggerType["onApiTrigger"] = 4] = "onApiTrigger";
    SCUTriggerType[SCUTriggerType["onToneDetect"] = 5] = "onToneDetect";
    SCUTriggerType[SCUTriggerType["onAlertingConnection"] = 6] = "onAlertingConnection";
    SCUTriggerType[SCUTriggerType["onZone"] = 7] = "onZone";
    SCUTriggerType[SCUTriggerType["onWebsocket"] = 8] = "onWebsocket";
})(SCUTriggerType = exports.SCUTriggerType || (exports.SCUTriggerType = {}));
var SCURuleOnEvent = /** @class */ (function (_super) {
    __extends(SCURuleOnEvent, _super);
    function SCURuleOnEvent(trigger, event) {
        var _this = _super.call(this, trigger) || this;
        _this.trigger = trigger;
        _this.event = event;
        return _this;
    }
    SCURuleOnEvent.prototype.toJson = function () {
        return {
            trigger: SCUTriggerType[this.trigger],
            event: SCURuleEventType[this.event],
        };
    };
    SCURuleOnEvent.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleOnEvent(cerealParse_1.ParseUtils.getEnum(o, 'trigger', SCUTriggerType), cerealParse_1.ParseUtils.getEnum(o, 'event', SCURuleEventType)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleOnEvent Model: " + e.message);
        }
    };
    return SCURuleOnEvent;
}(SCURuleOn));
exports.SCURuleOnEvent = SCURuleOnEvent;
var SCURuleEventType;
(function (SCURuleEventType) {
    SCURuleEventType[SCURuleEventType["initComplete"] = 0] = "initComplete";
    SCURuleEventType[SCURuleEventType["newJob"] = 1] = "newJob";
    SCURuleEventType[SCURuleEventType["toneStop"] = 2] = "toneStop";
    SCURuleEventType[SCURuleEventType["ttsTranslateComplete"] = 3] = "ttsTranslateComplete";
    SCURuleEventType[SCURuleEventType["ttsStop"] = 4] = "ttsStop";
    SCURuleEventType[SCURuleEventType["jobExpire"] = 5] = "jobExpire";
    SCURuleEventType[SCURuleEventType["audioStart"] = 6] = "audioStart";
    SCURuleEventType[SCURuleEventType["audioStop"] = 7] = "audioStop";
})(SCURuleEventType = exports.SCURuleEventType || (exports.SCURuleEventType = {}));
var SCURuleOnAssignment = /** @class */ (function (_super) {
    __extends(SCURuleOnAssignment, _super);
    function SCURuleOnAssignment(trigger, units) {
        var _this = _super.call(this, trigger) || this;
        _this.trigger = trigger;
        _this.units = units;
        return _this;
    }
    SCURuleOnAssignment.prototype.toJson = function () {
        return {
            trigger: SCUTriggerType[this.trigger],
            units: this.units,
        };
    };
    SCURuleOnAssignment.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleOnAssignment(cerealParse_1.ParseUtils.getEnum(o, 'trigger', SCUTriggerType), cerealParse_1.ParseUtils.getArray(o, 'units')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleOnAssignment Model: " + e.message);
        }
    };
    return SCURuleOnAssignment;
}(SCURuleOn));
exports.SCURuleOnAssignment = SCURuleOnAssignment;
var SCURuleOnInput = /** @class */ (function (_super) {
    __extends(SCURuleOnInput, _super);
    function SCURuleOnInput(trigger, device, pin, condition) {
        var _this = _super.call(this, trigger) || this;
        _this.trigger = trigger;
        _this.device = device;
        _this.pin = pin;
        _this.condition = condition;
        return _this;
    }
    SCURuleOnInput.prototype.toJson = function () {
        return {
            trigger: SCUTriggerType[this.trigger],
            device: this.device,
            pin: this.pin,
            condition: scuConfig_1.SCUIODeviceInputCondition[this.condition],
        };
    };
    SCURuleOnInput.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleOnInput(cerealParse_1.ParseUtils.getEnum(o, 'trigger', SCUTriggerType), cerealParse_1.ParseUtils.getString(o, 'device'), cerealParse_1.ParseUtils.getNumber(o, 'pin'), cerealParse_1.ParseUtils.getEnum(o, 'condition', scuConfig_1.SCUIODeviceInputCondition)));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleOnInput Model: " + e.message);
        }
    };
    return SCURuleOnInput;
}(SCURuleOn));
exports.SCURuleOnInput = SCURuleOnInput;
var SCURuleOnCron = /** @class */ (function (_super) {
    __extends(SCURuleOnCron, _super);
    function SCURuleOnCron(trigger, cron) {
        var _this = _super.call(this, trigger) || this;
        _this.trigger = trigger;
        _this.cron = cron;
        return _this;
    }
    SCURuleOnCron.prototype.toJson = function () {
        return {
            trigger: SCUTriggerType[this.trigger],
            cron: this.cron,
        };
    };
    SCURuleOnCron.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleOnCron(cerealParse_1.ParseUtils.getEnum(o, 'trigger', SCUTriggerType), cerealParse_1.ParseUtils.getString(o, 'cron')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleOnCron Model: " + e.message);
        }
    };
    return SCURuleOnCron;
}(SCURuleOn));
exports.SCURuleOnCron = SCURuleOnCron;
var SCURuleOnAPITrigger = /** @class */ (function (_super) {
    __extends(SCURuleOnAPITrigger, _super);
    function SCURuleOnAPITrigger(trigger, apiTriggerId) {
        var _this = _super.call(this, trigger) || this;
        _this.trigger = trigger;
        _this.apiTriggerId = apiTriggerId;
        return _this;
    }
    SCURuleOnAPITrigger.prototype.toJson = function () {
        return {
            trigger: SCUTriggerType[this.trigger],
            apiTriggerId: this.apiTriggerId,
        };
    };
    SCURuleOnAPITrigger.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleOnAPITrigger(cerealParse_1.ParseUtils.getEnum(o, 'trigger', SCUTriggerType), cerealParse_1.ParseUtils.getString(o, 'apiTriggerId')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleOnAPITrigger Model: " + e.message);
        }
    };
    return SCURuleOnAPITrigger;
}(SCURuleOn));
exports.SCURuleOnAPITrigger = SCURuleOnAPITrigger;
var SCURuleOnToneDetect = /** @class */ (function (_super) {
    __extends(SCURuleOnToneDetect, _super);
    function SCURuleOnToneDetect(trigger, bandpass, tones) {
        var _this = _super.call(this, trigger) || this;
        _this.trigger = trigger;
        _this.bandpass = bandpass;
        _this.tones = tones;
        return _this;
    }
    SCURuleOnToneDetect.prototype.toJson = function () {
        return {
            trigger: SCUTriggerType[this.trigger],
            bandpass: this.bandpass,
            tones: this.tones,
        };
    };
    SCURuleOnToneDetect.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleOnToneDetect(cerealParse_1.ParseUtils.getEnum(o, 'trigger', SCUTriggerType), cerealParse_1.ParseUtils.getArray(o, 'bandpass'), cerealParse_1.ParseUtils.getArray(o, 'tones')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleOnToneDetect Model: " + e.message);
        }
    };
    return SCURuleOnToneDetect;
}(SCURuleOn));
exports.SCURuleOnToneDetect = SCURuleOnToneDetect;
var SCURuleOnAlertingConnection = /** @class */ (function (_super) {
    __extends(SCURuleOnAlertingConnection, _super);
    function SCURuleOnAlertingConnection(trigger, connected) {
        var _this = _super.call(this, trigger) || this;
        _this.trigger = trigger;
        _this.connected = connected;
        return _this;
    }
    SCURuleOnAlertingConnection.prototype.toJson = function () {
        return {
            trigger: SCUTriggerType[this.trigger],
            connected: this.connected,
        };
    };
    SCURuleOnAlertingConnection.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleOnAlertingConnection(cerealParse_1.ParseUtils.getEnum(o, 'trigger', SCUTriggerType), cerealParse_1.ParseUtils.getBoolean(o, 'connected')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleOnAlertingConnection Model: " + e.message);
        }
    };
    return SCURuleOnAlertingConnection;
}(SCURuleOn));
exports.SCURuleOnAlertingConnection = SCURuleOnAlertingConnection;
var SCURuleOnZone = /** @class */ (function (_super) {
    __extends(SCURuleOnZone, _super);
    function SCURuleOnZone(name) {
        var _this = _super.call(this, SCUTriggerType.onZone) || this;
        _this.name = name;
        return _this;
    }
    SCURuleOnZone.prototype.toJson = function () {
        return {
            trigger: SCUTriggerType[this.trigger],
            name: this.name,
        };
    };
    SCURuleOnZone.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleOnZone(cerealParse_1.ParseUtils.getString(o, 'name')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleOnZone Model: " + e.message);
        }
    };
    return SCURuleOnZone;
}(SCURuleOn));
exports.SCURuleOnZone = SCURuleOnZone;
var SCURuleOnWebsocket = /** @class */ (function (_super) {
    __extends(SCURuleOnWebsocket, _super);
    function SCURuleOnWebsocket(id, message) {
        var _this = _super.call(this, SCUTriggerType.onWebsocket) || this;
        _this.id = id;
        _this.message = message;
        return _this;
    }
    SCURuleOnWebsocket.prototype.toJson = function () {
        return {
            trigger: SCUTriggerType[this.trigger],
            id: this.id,
            message: this.message,
        };
    };
    SCURuleOnWebsocket.parse = function (o) {
        try {
            return cerealParse_1.ParseUtils.parseSuccess(new SCURuleOnWebsocket(cerealParse_1.ParseUtils.getString(o, 'id'), cerealParse_1.ParseUtils.getString(o, 'message')));
        }
        catch (e) {
            return cerealParse_1.ParseUtils.parseFailure("Invalid SCURuleOnWebsocket: " + e.message);
        }
    };
    return SCURuleOnWebsocket;
}(SCURuleOn));
exports.SCURuleOnWebsocket = SCURuleOnWebsocket;
//# sourceMappingURL=scuRuleOn.js.map